import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to top whenever route changes
 * Place this inside Router but outside Routes
 */
const ScrollToTop = () => {
  const { pathname, search, hash, key } = useLocation();

  useLayoutEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, search, hash, key]);

  return null;
};

export default ScrollToTop;
